import { importProduct } from "../api";
import Import from "@/components/Import";

const ImportProduct = () => {
    return <Import title="sản phẩm" action={importProduct} template="https://boadmin.qsland.vn/mau_import_product.xlsx" />;
};

export default ImportProduct;